import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import Loading from '../components/Loading'
import { ErrorReloading } from '../components/Error'
import GeolocationManager from '../components/GeolocationManager'
import WakeLockManager from '../components/WakeLockManager'
import PersistedRouteManager from '../components/PersistedRouteManager'
import { reverse } from '../urls'
import { retry } from '../utils'

import Home from './Home'

const Viewer = React.lazy(() => retry(() => import('./Viewer'), { fallback: ErrorReloading }))
const Planner = React.lazy(() => retry(() => import('./Planner'), { fallback: ErrorReloading }))
const ErrorTest = React.lazy(() => retry(() => import('../components/ErrorTest')))

const App = (props) => {
  return (
    <>
      <Switch>
        <Route exact path={[reverse(null)]}>
          <Home/>
        </Route>

        <Route exact path='/test/error/'>
          <Suspense fallback={<Loading/>}>
            <ErrorTest/>
          </Suspense>
        </Route>

        <Route exact path='/planner/'>
          <Suspense fallback={<Loading/>}>
            <Planner/>
          </Suspense>
        </Route>

        <Route path={reverse(':route_id', null, null)}>
          <Suspense fallback={<Loading/>}>
            <Viewer/>
          </Suspense>
        </Route>
      </Switch>

      <PersistedRouteManager/>
      <GeolocationManager/>
      <WakeLockManager/>
    </>
  )
}

export default App
